import { mapState, mapGetters, mapActions } from 'vuex'

export const agentListComputed = {
  ...mapState('agentList', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('agentList', ['getAgentList']),
}

export const agentListMethods = mapActions('agentList', [
  'fetchingAgentList',
  'resetAgentList',
  'deleteAgentById',
])
